import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { AgmCoreModule } from '@agm/core';
import { FormsModule } from '@angular/forms';


import { RoutingModule } from './routing/routing.module';

import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about-us/about-us.component';
import { ContactUsComponent} from './pages/contact-us/contact-us.component';

import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { TakeOurComponent } from './shared/take-our/take-our.component';
import { ProductsComponent } from './pages/products/products.component';
import { PersonalizedOfferComponent } from './shared/personalized-offer/personalized-offer.component';
import { BlogComponent } from './pages/blog/blog.component';
import { PressComponent } from './pages/press/press.component';
import { CareersComponent } from './pages/careers/careers.component';
import { LoginComponent } from './shared/login/login.component';
import { SignUpComponent } from './shared/sign-up/sign-up.component';
import { TitleToolboxComponent } from './pages/products/title-toolbox/title-toolbox.component';
import { BlogArticleComponent } from './pages/blog/blog-article/blog-article.component';
import { CareersDetailComponent } from './pages/careers/careers-detail/careers-detail.component';
import { ForgotPasswordComponent } from './shared/forgot-password/forgot-password.component';
import { RelationShipsComponent } from './shared/relation-ships/relation-ships.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { RecaptchaComponent } from './shared/recaptcha/recaptcha.component';
import { ReactiveFormsModule   } from '@angular/forms';
import { ReboGatewayComponent } from './pages/products/rebo-gateway/rebo-gateway.component';
import { PremiereListComponent } from './pages/products/premiere-list/premiere-list.component';
import { InvestorsTitleToolboxComponent } from './pages/products/investors-title-toolbox/investors-title-toolbox.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    ContactUsComponent,
    AboutComponent,
    TakeOurComponent,
    ProductsComponent,
    PersonalizedOfferComponent,
    BlogComponent,
    PressComponent,
    CareersComponent,
    LoginComponent,
    SignUpComponent,
    TitleToolboxComponent,
    ReboGatewayComponent,
    PremiereListComponent,
    BlogArticleComponent,
    CareersDetailComponent,
    ForgotPasswordComponent,
    RelationShipsComponent,
    RecaptchaComponent,
    InvestorsTitleToolboxComponent
  ],
  imports: [
    BrowserModule,
    RoutingModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    AgmCoreModule.forRoot({apiKey: 'AIzaSyC4TSJHA7SHGtRLm3sW_bMW70qYRqRh8AI'}),
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/app.module.ts